module.exports = __webpack_public_path__ + "static/media/mobile-top.a38cdf1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/mobile-top.svg
// module id = 278
// module chunks = 0